import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { ProjectMenu } from '../components/ProjectMenu';
import { DispatchBrain } from '../components/DispatchBrain';
import { StackSection } from '../components/StackSection';
import { Faq } from '../components/Faq';
import { NextStepPanel } from '../components/NextStepPanel';
import { usePageTitle } from '../hooks/usePageTitle';
export function Services() {
  usePageTitle('Services | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Services" title="Four ways in. One system underneath." data-id="element-555" data-mp="3t9nwknr9tzz3" />
      <ProjectMenu data-id="element-556" data-mp="b3ssrjceva46" />
      <DispatchBrain eyebrow="Inside the system" showAgreement data-id="element-557" data-mp="b4avmytkwml2" />
      <StackSection data-id="element-558" data-mp="64ybilu3dtm6" />
      <Faq data-id="element-559" data-mp="64galbwhir7x" />
      <NextStepPanel title="Start with the free part." buttonLabel="Book your free Response Audit" to="/book" data-id="element-560" data-mp="65zpay2hsu7l" />
    </>;
}